/* eslint-disable no-useless-catch */
/* eslint-disable no-undef */
import { ENV } from "../utils";

export class Report {
  baseApi = ENV.BASE_API;
  async getMe(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/me`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  /* ADMIN */
  async coursesByTeacher(accessToken, selectedTeacher, format) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REPORT}/courses-by-teacher/${selectedTeacher}/${format}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      
      if (!response.ok) throw new Error('Error al generar el reporte');
      
      // Retornar el blob directamente
      return await response.blob();
    } catch (error) {
      throw error;
    }
  }

  async studentsByGrade(accessToken, selectedAcademicCycle, selectedGrade, format) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REPORT}/students-by-grade/${selectedAcademicCycle}/${selectedGrade}/${format}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      
      if (!response.ok) throw new Error('Error al generar el reporte');
      
      // Retornar el blob directamente
      return await response.blob();
    } catch (error) {
      throw error;
    }
  }

  async attendancesByGrade(accessToken, selectedAcademicCycle, selectedGrade, selectedYear, selectedMonth, format) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REPORT}/attendances-by-grade/${selectedAcademicCycle}/${selectedGrade}/${selectedYear}/${selectedMonth}/${format}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      
      if (!response.ok) throw new Error('Error al generar el reporte');
      
      // Retornar el blob directamente
      return await response.blob();
    } catch (error) {
      throw error;
    }
  }
  /* FIN - ADMIN */

  /* ACADEMIC */
  async notesByGrade(accessToken, selectedAcademicCycle, selectedGrade, format) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REPORT}/notes-by-grade/${selectedAcademicCycle}/${selectedGrade}/${format}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      
      if (!response.ok) throw new Error('Error al generar el reporte');
      
      // Retornar el blob directamente
      return await response.blob();
    } catch (error) {
      throw error;
    }
  }

  async notesByStudent(accessToken, selectedAcademicCycle, selectedGrade, selectedStudent, format) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REPORT}/notes-by-student/${selectedAcademicCycle}/${selectedGrade}/${selectedStudent}/${format}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      
      if (!response.ok) throw new Error('Error al generar el reporte');
      
      // Retornar el blob directamente
      return await response.blob();
    } catch (error) {
      throw error;
    }
  }
  /* FIN - ACADEMIC */

}
